import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import PdfOutput from '../../containers/FeedingGuidelines/PdfOutput';
import Loader from './../../components/Loader/Loader';
import fetchFeedingGuidelinesPrintAction from './../../store/actions/fetch/fetchFeedingGuidelinesPrintAction';
import {setDeviceSizeToModal} from '../../helpers/ScreenshotHelper';

import {isMobile} from 'react-device-detect';

import * as actionTypes from './../../store/actions/feedingGuidelinesPrintAction';

class PdfOutputModal extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {

    const {data, pending, ready, error, name, clinicRecordNumber} = this.props;

    if (pending || !ready) return(null);

    if (isMobile)
      setDeviceSizeToModal();

    return (
      <div className="nppe2-fc-feeding-guidelines-outer__modal">

        <div className="nppe2-fc-feeding-guidelines-outer__loader"
          id="nppe2-fc-feeding-guidelines-outer__loader">
          <Loader/>
        </div>

        <PdfOutput
          name={name}
          clinicRecordNumber={clinicRecordNumber}
          data={data}/>

      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesPrintReducer.data,
    pending: state.feedingGuidelinesPrintReducer.pending,
    ready: state.feedingGuidelinesPrintReducer.ready,
    error: state.feedingGuidelinesPrintReducer.error,
    name: state.petInfoReducer.petName,
    clinicRecordNumber: state.petInfoReducer.clinicRecordNumber,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesPrintAction
      },
      dispatch,
    ),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfOutputModal);
